import { MultiLanguageField } from '@olymp/shared';

export interface IDirectory {
  id?: number;
  name: MultiLanguageField;
  code?: string;
  inn?: string;
}

export enum DIRECTORY_API_URL {
  Roles = 'roles',
  Regions = 'spregions',
  Districts = 'spdistricts',
  SchoolGrades = 'spschoolgrades',
  SchoolSubjects = 'spschoolsubjects',
  StudyYears = 'spstudyyears',
  Permissions = 'permissions/get-all',
  Institutions = 'spinstitutions',
  Organizations = 'sporganizationtypes',
  SchoolLegalForms = 'spschoollegalforms',
  SchoolTypes = 'spschooltypes',
  SchoolManagementForms = 'spschoolmanagementforms',
  SPTranslate = 'sptranslations',
  SPLanguages = 'splanguages',
  ERPInstitutions = 'spinstitutions/create-by-inn',
  AsyncDirector = 'admin/sync-erp-directors',
  SearchInstitutionByInn = 'spinstitutions/infobyinn',
  InsititutionClasses = 'spinstitutionclasses',
  SpAnswerSheetTemplate = 'spanswersheettemplate',
}
